
const projectWidgets: any = {
};

export default projectWidgets;
